export default "__VITE_ASSET__BRt_gezB__"